export function validateShopName(shopName) {
  return (
    Boolean(shopName) && // not null or undefined
    shopName.length >= 4 && // at least 4 characters
    /^[A-Za-z0-9-]+$/.test(shopName) && // all basic letters, numbers or dash
    !/^\d+$/.test(shopName) && // numbers only not allowed (shop ids)
    !/^-+$/.test(shopName)
  ); // dashes only not allowed
}
